import backend from "../../api/api";
import { store } from "../../redux/store";


const getConfig = () => {
  const token = store.getState().auth.token;
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

const baseURL = "api/product/damage-stock/";

export const getAllDamageStock = async () => {
  try {
    const res = await backend.get(baseURL, getConfig());
    return res.data;
  } catch (error) {
    console.error("Error fetching DamageStock:", error);
    throw error;
  }
};

export const getSpecificDamageStock = async (id) => {
  try {
    const res = await backend.get(`${baseURL}${id}/`, getConfig());
    return res.data;
  } catch (error) {
    console.error("Error fetching specific DamageStock:", error);
    throw error;
  }
};

export const createDamageStock = async (data) => {
  try {
    const res = await backend.post(baseURL, data, getConfig());
    return res.data;
  } catch (error) {
    console.error("Error creating DamageStock:", error);
    throw error.response.data || error;
  }
};

export const updateDamageStock = async (id, data) => {
  try {
    const res = await backend.put(`${baseURL}${id}/`, data, getConfig());
    return res.data;
  } catch (error) {
    console.error("Error updating DamageStock:", error);
    throw error;
  }
};

export const deleteDamageStock = async (id) => {
  try {
    await backend.delete(`${baseURL}${id}/`, getConfig());
    return true;
  } catch (error) {
    console.error("Error deleting DamageStock:", error);
    throw error;
  }
};
